import debounce from 'lodash.debounce';
import { Options } from 'vue-class-component';
import {
  ActuatorModalityType,
  ThermoAssociatedPump,
  ThermoTypeOfObject,
} from '@/../client-generator/generated-clients/plants';
import ThermoGeneralStep from '../ThermoGeneralStep';
import { PlantEntityType } from '@/../client-generator/generated-clients/configurations';
import { NamingService } from '@/core/services/naming.service';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { NAME_VALIDATION_DEBOUNCE_TIME } from '@/core/utils/utils';

@Options({
  name: 'Step0GeneralProperties',
  watch: {
    'roomObject.thermoTypeOfObject': function (newValue, oldValue) {
      if (oldValue != undefined) this.resetActuatorModalityType();
    },
    'roomObject.name': function () {
      this.verifyValidityOfName();
    },
  },
})
export default class Step0GeneralProperties extends ThermoGeneralStep {
  isValidName = true;
  initialName!: string;
  invalidNameReason: string = '';

  created() {
    this.initialName = this.roomObject.name ?? '';

    this.verifyValidityOfName = debounce(
      this.verifyValidityOfName,
      NAME_VALIDATION_DEBOUNCE_TIME
    );
  }

  private async verifyValidityOfName() {
    this.$store.dispatch(SET_APP_LOADING, true);
    const validName = await NamingService.isValidEntityTypeName(
      this.roomObject.name
    );

    if (this.initialName !== this.roomObject.name && !validName) {
      const suggestedName = await NamingService.suggestNextValidEntityName({
        eType: PlantEntityType.ROOM_OBJECT,
        plantId: this.plantId,
        metadata: {
          roomType: +this.roomType,
          roomObjectType: this.roomObject.type,
          room: { name: this.roomName } as any,
        },
      });
      this.isValidName = validName;
      this.invalidNameReason = this.$t(
        `uniqueNaming.validationErrorWithSuggestion`,
        { suggestedName }
      );
      this.$emit('next-enabled', false);
    } else {
      this.isValidName = true;
      this.invalidNameReason = '';
      this.$emit('next-enabled', true);
    }
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  get typeOptions() {
    return Object.keys(ThermoTypeOfObject)
      .filter(
        (value) =>
          !isNaN(Number(value)) && Number(value) != ThermoTypeOfObject.None
      )
      .map((value) => Number(value));
  }
  get associatedPumpOptions() {
    return Object.keys(ThermoAssociatedPump)
      .filter(
        (value) =>
          !isNaN(Number(value)) && Number(value) != ThermoAssociatedPump.None
      )
      .map((value) => Number(value));
  }

  getOptionName(type: ThermoTypeOfObject) {
    return this.$t(`AppResource.${ThermoTypeOfObject[type]}`);
  }

  getAssociatedOptionName(type: ThermoAssociatedPump) {
    return this.$t(`AppResource.${ThermoAssociatedPump[type]}`);
  }

  resetActuatorModalityType() {
    this.roomObject.actuatorModalityType = ActuatorModalityType.None;
  }
}
